const propelInit = function() {
class FilterDropdown {
	constructor(element) {
		this.filter = element;
		this.button = this.filter.querySelector('.filter-dropdown__button');

		this.optionButtons = this.filter.querySelectorAll(
			'.filter-dropdown__option'
		);

		this.handleGlobalEvents = this.handleGlobalEvents.bind(this);
		this.init();
	}

	init() {
		this.button.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.toggle();
		});

		this.optionButtons.forEach((optionButton) => {
			optionButton.addEventListener('click', (e) => {
				this.handleOptionClick(e, optionButton);
			});
		});

		document.addEventListener('propel-tab-changed', (e) => {
			this.handleTabChanged(e);
		});
	}

	setSelectedOption(optionButton) {
		this.button.textContent = optionButton.textContent;

		this.optionButtons.forEach((button) => {
			if (button !== optionButton) {
				button.setAttribute('aria-selected', 'false');
			}
		});

		optionButton.setAttribute('aria-selected', 'true');
	}

	handleTabChanged(e) {
		if (!e.target?.id) {
			return;
		}

		const matchingOption = this.filter.querySelector(
			`.filter-dropdown__option[data-target="#${e.target.id}"]`
		);

		if (matchingOption) {
			this.setSelectedOption(matchingOption);
		}
	}

	handleOptionClick(e, optionButton) {
		this.close();
		this.setSelectedOption(optionButton);

		const targetSelector = optionButton?.dataset?.target ?? null;

		if (targetSelector) {
			const targetElement = this.findTargetElement(targetSelector);

			if (targetElement) {
				targetElement.dispatchEvent(
					new CustomEvent('propel-dropdown-option-selected', {
						bubbles: true,
						detail: { source: optionButton },
					})
				);
			}
		}
	}

	findTargetElement(selector) {
		let scope = this.filter.parentElement;

		while (scope) {
			const targetElement = scope.querySelector(selector);

			if (targetElement) {
				return targetElement;
			}

			scope = scope.parentElement;
		}

		return null;
	}

	toggle() {
		const isExpanded = this.button.getAttribute('aria-expanded') === 'true';

		if (isExpanded) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.button.setAttribute('aria-expanded', 'true');
		document.addEventListener('click', this.handleGlobalEvents);
		document.addEventListener('keydown', this.handleGlobalEvents);
	}

	close() {
		this.button.setAttribute('aria-expanded', 'false');
		document.removeEventListener('click', this.handleGlobalEvents);
		document.removeEventListener('keydown', this.handleGlobalEvents);
	}

	handleGlobalEvents(e) {
		if (e.type === 'keydown' && e.key === 'Escape') {
			this.close();
			this.button.focus();
		}

		if (e.type === 'click' && !this.filter.contains(e.target)) {
			this.close();
		}
	}
}

const dropdowns = document.querySelectorAll('.filter-dropdown');
dropdowns.forEach((dropdown) => new FilterDropdown(dropdown));

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['filter-dropdown'] = window.propel.blocks['filter-dropdown'] || {};
window.propel.blocks['filter-dropdown'].script = propelInit;
